import { DATA_API_BASE_URL } from '../config/api';
import { getJson } from './http';

/** One entry of GET /data-agg/jobs, as the backend's jobs route sends it. */
export interface Job {
  job_id: string;
  agg_type: string;
  measure: string | null;
  start_time: string | null;
  end_time: string | null;
  activity_type: string | null;
  geo_type: string | null;
  geo_ids: (string | number)[];
  origin_geo_type: string | null;
  origin_geo_ids: (string | number)[];
  destination_geo_type: string | null;
  destination_geo_ids: (string | number)[];
  full: boolean;
  status: string;
  http_path: string | null;
  created_at: string | null;
  updated_at: string | null;
}

interface JobsApiResponse {
  jobs: Job[];
}

export const jobsApi = {
  async getAllJobs(): Promise<Job[]> {
    const result = await getJson<JobsApiResponse | null>(DATA_API_BASE_URL, '/data-agg/jobs');
    if (!result || !Array.isArray(result.jobs)) {
      throw new Error('The API sent the jobs list in an unexpected shape.');
    }
    return result.jobs;
  },
};
